import { render, staticRenderFns } from "./ChineseTable.vue?vue&type=template&id=5263d774&scoped=true&"
import script from "./ChineseTable.vue?vue&type=script&lang=js&"
export * from "./ChineseTable.vue?vue&type=script&lang=js&"
import style0 from "./ChineseTable.vue?vue&type=style&index=0&id=5263d774&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5263d774",
  null
  
)

export default component.exports